import React, {useEffect} from 'react';
import HeaderSubPageTiny from "./partial/HeaderSubPageTiny";

const AccessibilityDeclaration = () => {
    useEffect(() => {
        document.title = `Barrierefreiheitserklärung`;
    }, []);
    return (
        <div>
            <div className="site wrapper-content">
                <HeaderSubPageTiny title={'Barrierefreiheitserklärung'}
                                   subtitle={'Barrierefreiheitserklärung'}></HeaderSubPageTiny>
                <section className="content-area">
                    <div className="container">
                        <div className="row">
                            <div className="site-main col-sm-12">
                                <h1 className="post_list_title">
                                    <span><strong>Barrierefreiheitserklärung</strong></span>
                                </h1>
                                <div>
                                    <section className="mx-auto p-4">
                                        <p>
                                            Wir sind bestrebt, unsere Website im Einklang mit den geltenden Vorschriften
                                            zur Barrierefreiheit zu gestalten. Für uns gelten folgende
                                            Rechtsvorschriften:
                                        </p>
                                        <ul className="mt-4">
                                            <li>das Hessische Behinderten-Gleichstellungsgesetz (HessBGG)</li>
                                            <li>die Hessische Verordnung über barrierefreie Informationstechnik (BITV HE
                                                2019)
                                            </li>
                                        </ul>
                                    </section>

                                    <section aria-labelledby="website-title"
                                             className="mx-auto p-4">
                                        <h2 id="website-title"
                                            className="text-2xl font-semibold mb-4">Website</h2>
                                        <p>
                                            Diese Erkl&auml;rung zur Barrierefreiheit gilt f&uuml;r die
                                            Website <a
                                            href="https://www.globalis.de/">https://www.globalis.de/</a> einschließlich
                                            aller Subdomains.
                                        </p>
                                    </section>

                                    <section aria-labelledby="feedback-title"
                                             className="mx-auto p-4">
                                        <h2 id="feedback-title"
                                            className="text-2xl font-semibold mb-4">Feedback und Kontak</h2>
                                        <p>Sollten Ihnen Mängel hinsichtlich der Barrierefreiheit auf unserer Website
                                            auffallen oder haben Sie Anmerkungen und Fragen, kontaktieren Sie uns bitte:
                                        </p>
                                        <p>GLOBALIS Erlebnisreisen GmbH<br/>
                                            Uferstra&szlig;e 24<br/>
                                            61137 Schöneck, Deutschland<br/>
                                            <br/>
                                            Telefon: 06187 / 4804 - 840<br/>
                                            Telefax: 06187 / 4804 - 335<br/>
                                            E-Mail: info(at)globalis.de<br/>
                                            Web: <a
                                                href="https://www.globalis.de/kontakt/">https://www.globalis.de/kontakt/</a><br/>
                                        </p>
                                    </section>

                                    <section aria-labelledby="hilfe-title"
                                             className="mx-auto p-4">
                                        <h2 id="hilfe-title"
                                            className="text-2xl font-semibold mb-4">Telefonische Hilfe f&uuml;r Menschen
                                            mit Behinderungen</h2>
                                        <p>Unterstützung für Menschen mit Behinderungen oder Nutzer unterstützender
                                            Technologien bieten wir telefonisch unter: 06187 / 4804 - 840
                                        </p>
                                    </section>

                                    <section aria-labelledby="stand-title"
                                             className="mx-auto p-4">
                                        <h2 id="stand-title"
                                            className="text-2xl font-semibold mb-4">Stand der Vereinbarkeit</h2>

                                        <p>Die nachstehend aufgeführten Inhalte sind nicht mit den einschlägigen
                                            gesetzlichen Vorschriften zur Barrierefreiheit vereinbar. Die Website wird
                                            nach bestem Wissen und Gewissen gemäß den geltenden gesetzlichen
                                            Vorschriften zur Barrierefreiheit überprüft und gepflegt. Dennoch kann es zu
                                            einzelnen Einschränkungen kommen, insbesondere bei:
                                        </p>
                                        <ul className="mt-4">
                                            <li>PDF-Dokumenten, die nicht vollständig barrierefrei aufbereitet sind</li>
                                            <li>Interaktive Elemente sind teilweise nicht per Tastatur bedienbar</li>
                                            <li>
                                                Bilder enthalten keine oder unzureichende Alternativtexte
                                            </li>
                                            <li>Farbkontraste in bestimmten Textbereichen sind unzureichend</li>
                                            <li>Formularfelder und Filterfunktionen sind nicht vollständig mit korrekten
                                                Labels versehen
                                            </li>
                                        </ul>
                                        <p>
                                            Wir arbeiten kontinuierlich an der Identifikation und Beseitigung dieser
                                            Barrieren.
                                        </p>
                                    </section>

                                    <section aria-labelledby="unverhältnismaeßige-belastung-title"
                                             className="mx-auto p-4">
                                        <h2 id="unverhältnismaeßige-belastung-title"
                                            className="text-2xl font-semibold mb-4">Unverhältnismäßige Belastung</h2>
                                        <p>
                                            Folgende Inhalte können derzeit nicht barrierefrei angeboten werden, da die
                                            Umsetzung mit unverhältnismäßigem Aufwand verbunden wäre:
                                        </p>
                                        <ul className="mt-4">
                                            <li>Nachträgliche barrierefreie Aufbereitung umfangreicher älterer
                                                PDF-Dokumente
                                            </li>
                                            <li>Vollständige barrierefreie Umsetzung von Drittanbieter-Komponenten auf
                                                die wir keinen Einfluss haben
                                            </li>
                                        </ul>
                                        <p>
                                            Wir bewerten regelmäßig den Aufwand und die Zumutbarkeit technischer
                                            Anpassungen und streben an, auch diese Inhalte mittelfristig möglichst
                                            barrierearm zu gestalten
                                        </p>
                                    </section>

                                    <section aria-labelledby="ausnahmen-title" className="mx-auto p-4">
                                        <h2 id="ausnahmen-title" className="text-2xl font-semibold mb-4">Ausnahmen vom
                                            Anwendungsbereich</h2>
                                        <p>
                                            Folgende nicht barrierefreie Inhalte auf dieser Website fallen nicht unter
                                            den Anwendungsbereich der Vorschriften zur Barrierefreiheit:
                                        </p>
                                        <ul className="mt-4">
                                            <li>
                                                Inhalte Dritter, die außerhalb unseres Einflussbereichs liegen (z. B.
                                                eingebettete Inhalte externer Anbieter)
                                            </li>
                                            <li>
                                                PDF-Dokumente, die vor dem 23.09.2018 veröffentlicht wurden und nicht
                                                aktiv genutzt werden
                                            </li>
                                            <li>
                                                Audio- und Videoinhalte, die vor dem 23.09.2020 veröffentlicht wurden
                                            </li>
                                        </ul>
                                        <p>
                                            Diese Inhalte sind von der gesetzlichen Verpflichtung zur Barrierefreiheit
                                            ausgenommen, werden jedoch bei Gelegenheit durch barrierearme Alternativen
                                            ersetzt, sofern möglich.
                                        </p>
                                    </section>

                                    <section aria-labelledby="alternativen-title"
                                             className="mx-auto p-4">
                                        <h2 id="alternativen-title"
                                            className="text-2xl font-semibold mb-4">Barrierefreie Alternativen</h2>
                                        <p>
                                            Für nicht barrierefreie Inhalte stellen wir auf Anfrage folgende
                                            Alternativen zur Verfügung:
                                        </p>
                                        <ul className="mt-4">
                                            <li>Informationen aus PDF-Dateien als barrierefreie Versionen (z. B. HTML
                                                oder barrierefreies PDF)
                                            </li>
                                            <li>Textliche Erläuterungen für komplexe Grafiken und Bilder
                                            </li>
                                            <li>Persönliche Unterstützung bei der Nutzung von Formularen oder Funktionen
                                                per E-Mail oder Telefon
                                            </li>
                                        </ul>
                                        <p>
                                            Bitte kontaktieren Sie uns, wenn Sie bestimmte Inhalte in barrierefreier
                                            Form benötigen. Wir bemühen uns um eine zeitnahe Bereitstellung.
                                        </p>
                                    </section>

                                    <section aria-labelledby="evaluationsmethode-title"
                                             className="mx-auto p-4">
                                        <h2 id="evaluationsmethode-title"
                                            className="text-2xl font-semibold mb-4">Evaluationsmethode</h2>
                                        <p>Die Barrierefreiheit dieser Website wurde durch eine Selbstbewertung auf
                                            Grundlage der Anforderungen der Barrierefreie-Informationstechnik-Verordnung
                                            (BITV 2.0) sowie der Web Content Accessibility Guidelines (WCAG) 2.1
                                            überprüft. Dabei kamen manuelle Prüfungen sowie unterstützende Werkzeuge wie
                                            automatisierte Tests und Screenreader-Simulationen zum Einsatz.
                                        </p>
                                    </section>

                                    <section aria-labelledby="durchsetzungsverfahren-title"
                                             className="mx-auto p-4">
                                        <h2 id="durchsetzungsverfahren-title"
                                            className="text-2xl font-semibold mb-4">Durchsetzungsverfahren</h2>
                                        <p>Sollten Sie der Ansicht sein
                                            , dass Sie durch eine nicht ausreichende barrierefreie Gestaltung unserer
                                            Website benachteiligt sind, können Sie sich an die zuständige
                                            Durchsetzungsstelle wenden. Diese erreichen Sie unter:
                                        </p>
                                        <p>
                                            Landesbeauftragte für barrierefreie IT<br/>
                                            Neue Bäue 2<br/>
                                            35390 Gießen<br/>

                                        </p>
                                        <p>Telefon: 0641 303-2901<br/>
                                            E-Mail: <a
                                                href="mailto:ueberwachung-lbit@rpgi.hessen.de">ueberwachung-lbit@rpgi.hessen.de</a>
                                        </p>
                                    </section>

                                    <section aria-labelledby="erstellung-title"
                                             className="mx-auto p-4">
                                        <h2 id="erstellung-title"
                                            className="text-2xl font-semibold mb-4">Erstellung der Erklärung</h2>
                                        <p>Diese Erklärung wurde am 02.05.2025 erstellt und zuletzt am 02.05.2025
                                            überprüft.
                                        </p>
                                    </section>

                                    <section className="mx-auto p-4">
                                        <p>Quelle: <a
                                            href="https://www.e-recht24.de/barrierefreiheitserklaerung.html">eRecht24</a>
                                        </p>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default AccessibilityDeclaration;